import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']

export const Container = styled.div`
  > ul {
    margin: 0px 0 16px;
    padding: 0px;
    padding-left: 18px;
    font-size: 14px;
    color: ${darkColor};
    font-weight: 400;
  }

  li {
    line-height: 165%;
  }
`

export const Label = styled.h1`
  color: ${darkColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 18px;
`

export const ImageBox = styled.div`
  width: 90px;
  height: 90px;
`